import { ActionsUnion, Nullable } from 'utils'
import { clientActionLogToServer } from './ClientAction'
import { ClientLogStream, LogSeverity } from './generated'

export const LogToServerActions = {
  logStore: (message: string, stack: string) =>
    clientActionLogToServer(
      {
        logSeverity: LogSeverity.WARN,
        message,
        debugInfo: { stack, selections: null, actionLog: null },
        logStream: ClientLogStream.GLOBAL
      },
      true
    ),
  logDataIntegrityError: (message: string, entityIntegrity: string = '') =>
    clientActionLogToServer(
      {
        logSeverity: LogSeverity.ERROR,
        message,
        debugInfo: { stack: entityIntegrity, selections: null, actionLog: null },
        logStream: ClientLogStream.GLOBAL
      },
      true
    ),
  logMessage: (logSeverity: LogSeverity, message: string, logStream: Nullable<ClientLogStream> = null) =>
    clientActionLogToServer({ logSeverity, message, logStream, debugInfo: null }, true)
}

export type LogToServerActions = ActionsUnion<typeof LogToServerActions>
